<template>
    <div class="content-container">
        <div class="table-wrapper">
            <!-- 上部分 -->
            <div class="top-box">
                <!-- 搜索 -->
                <div class="search-box">
                    <div class="list">
                        <label>{{ $t('table.customer.thead.name') + '：' }}</label>
                        <a-input v-model="searchForm.name" :placeholder="$t('table.customer.thead.placeholder')" />
                    </div>
                    <div class="btns">
                        <a-button type="primary" @click="searchEvent"
                            >{{ $t(`actionTitles.search`)
                            }}</a-button>
                    </div>
                </div>
                <div class="btns">
                    <a-button type="primary" @click="downloadAll"
                        >{{ $t(`actionTitles.download`)
                        }}</a-button>
                </div>
            </div>



            <!-- 表格-->
            <a-table :data-source="tableData" :pagination="pagination" :row-key="record => record.id"
                @change="handleTableChange">
                <a-table-column key="name" :title="$t('table.customer.thead.name')" data-index="name" />
                <a-table-column key="cover" :title="$t('table.customer.thead.avatar')" data-index="cover" align="center">
                    <template slot-scope="text, record">
                        <img class="cover-img" :src="record.avatar || defaultImg" @error="imageError">
                    </template>
                </a-table-column>
                <a-table-column key="leader" :title="$t('table.customer.thead.phone')" data-index="leader" align="center">
                    <template slot-scope="text, record">
                        {{ record.phone ? record.phone : '--' }}
                    </template>
                </a-table-column>
                <a-table-column key="phone" :title="$t('table.customer.thead.lastTime')" data-index="phone" align="center">
                    <template slot-scope="text, record">
                        {{ record.update_time ? record.update_time : '--' }}
                    </template>
                </a-table-column>
                <a-table-column key="progress_rate_text" :title="$t('table.customer.thead.customerInfo')"
                    data-index="progress_rate_text" align="center">
                    <template slot-scope="text, record">
                        <a @click="customerInfo(record)">{{
                            $t("table.customer.thead.customerInfo")
                        }}</a>
                        <a-divider type="vertical" />
                        <a @click="download(record)">{{ $t("table.customer.thead.download") }}</a>
                    </template>
                </a-table-column>
            </a-table>
        </div>

        <a-modal :visible="customerInfoVisible" :width="750" :title="$t('table.customer.thead.name')" :footer="null"
            @cancel="closeCustomerInfo">
            <div>
                <ul>
                    <li v-for="(item, index) in customerData" :key="index">
                        Date: {{ item.date_time }}
                        <ul>
                            <li v-for="(dataItem, dataIndex) in item.data" :key="dataIndex" class="list-item">
                                <img :src="getIcon(dataItem.type)" class="record-icon">
                                <span class="record-text">{{ getActionText(dataItem.type, dataItem.work_name) }}</span>
                                <span class="record-time">{{ dataItem.create_time }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </a-modal>

    </div>
</template>

<script>
import { getUserCustomerList, getCustomerDetails, exportAllCustomerDetails, exportCustomerDetails } from "@/api/customer"
import { mapState } from "vuex";
export default {
    name: "List",
    data() {
        return {
            defaultImg: require('@/assets/default_h.jpg'),
            customer_icon_1: require('@/assets/img/customer_icon_1.png'),
            customer_icon_2: require('@/assets/img/customer_icon_2.png'),
            customer_icon_3: require('@/assets/img/customer_icon_3.png'),
            customer_icon_4: require('@/assets/img/customer_icon_4.png'),
            currentImage: "",
            tableData: [],
            searchForm: {
                name: "",
                order: [],
            },
            pagination: {
                showQuickJumper: true,
                current: 1,
                pageSize: 10,
                total: 0,
            },
            loading: false,
            searchParam: {
                type: 1,
                current_page: 1,
                per_page: 10
            },
            isTeam: 0,//是否是團隊帳號 0為個人，1為團隊帳號
            teamType: 1,//查看團隊個人還是團隊總專案 1為個人 2為團隊
            customerInfoVisible: false,
            mouth_enum: 1,
            customerData: [],
            currentId: 0,
        }
    },
    props: {
        record: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.user.userInfo,
        }),
    },
    mounted() {
        this.isTeam = parseInt(this.userInfo.team_id)
        this.getList();
        this.currentImage = this.record.avatar || this.defaultImg;
    },
    methods: {
        getIcon(type) {
            switch (type) {
                case 1:
                    return this.customer_icon_4;
                case 2:
                    return this.customer_icon_1;
                case 3:
                    return this.customer_icon_2;
                case 4:
                    return this.customer_icon_3;
            }
        },
        getActionText(type, workName) {
            switch (type) {
                case 1:
                    return `留言 "${workName}"`;
                case 2:
                    return `查看 "${workName}"`;
                case 3:
                    return `發起 "${workName}" 語音聊天系統`;
                case 4:
                    return `掛斷 "${workName}" 語音聊天系統`;
            }
        },

        closeCustomerInfo() {
            this.customerInfoVisible = false;
            this.customerData = [];
            this.mouth_enum = 1;
        },
        imageError(event) {
            event.target.src = this.defaultImg;
        },
        downloadAll() {
            exportAllCustomerDetails().then((res) => {
                console.log(res);
                let downloadElement = document.createElement("a");
                downloadElement.setAttribute('download', res.data.name);
                downloadElement.href = res.data.url;
                document.body.appendChild(downloadElement);
                downloadElement.click(); //點擊下載
                document.body.removeChild(downloadElement); //下載完成移除元素
            })
                .catch((error) => {
                    console.error(error);
                });
        },
        download(data) {
            console.log(data);
            exportCustomerDetails(data).then((res) => {
                console.log(res);
                let downloadElement = document.createElement("a");
                downloadElement.setAttribute('download', res.data.name);
                downloadElement.href = res.data.url;
                document.body.appendChild(downloadElement);
                downloadElement.click(); //點擊下載
                document.body.removeChild(downloadElement); //下載完成移除元素
            })
                .catch((error) => {
                    console.error(error);
                });
        },
        customerInfo(data) {
            this.customerInfoVisible = true;
            this.customerData = [];
            this.mouth_enum = 1;
            this.fetchCustomerDetails(data.id);
            this.currentId = data.id;
            console.log('id', data);
        },

        fetchCustomerDetails(id) {
            getCustomerDetails({ id: id, mouth_enum: this.mouth_enum })
                .then((res) => {
                    console.log('res', res.data);
                    const isfinish = res.data.mouth_enum === 12;
                    if (isfinish) {
                        this.customerData = [...this.customerData, ...res.data.customer_log];
                        console.log('this.customerData', this.customerData);
                    } else {
                        this.customerData = [...this.customerData, ...res.data.customer_log];
                        this.mouth_enum = res.data.mouth_enum + 1;
                        this.fetchCustomerDetails(id);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching customer details:", error);
                });
            console.log(this.customerData);
        },

        //獲取列表
        getList() {
            this.loading = true;
            this.searchParam = {
                ...this.searchParam,
                ...this.searchForm,
                type: this.isTeam ? this.teamType : 1,
                current_page: this.pagination.current,
                per_page: this.pagination.pageSize
            }
            console.log('type', this.searchParam);
            getUserCustomerList(this.searchParam)
                .then((res) => {
                    this.loading = false;
                    this.tableData = res.data.data
                    this.pagination.total = res.data.total

                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Error fetching customer list:", error);
                });
        },
        //table 翻頁
        handleTableChange(pagination, filters, sorter) {
            this.pagination = pagination;
            if (Object.keys(sorter).length > 0) {
                let field = sorter.field;
                let orderStr = sorter.order == "ascend" ? "asc" : "desc";

                let order = {};
                order[field] = orderStr;
                this.searchForm.order = order;
            }
            this.getList();
        },
        //切換個人、團隊總專案
        changeTeamType(e) {
            this.teamType = e.target.value
            this.pagination.current = 1
            this.getList()
        },
        //搜索
        searchEvent() {
            this.pagination.current = 1
            this.getList()
        }
    }
}
</script>

<style lang="less" scoped>
.cover-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
}

.operate-link {
    color: #0d95e8;
    cursor: pointer;
}

.top-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .search-box {
        display: flex;
        align-items: center;

        .list {
            display: flex;
            align-items: center;

            label {
                flex-shrink: 0;
                margin-right: 5px;
            }
        }

        .btns {
            display: flex;
            align-items: center;

            .ant-btn {
                margin-left: 10px;
            }

            .searchBtn {
                background-color: #7101ad;
                border-color: #7101ad;
            }
        }
    }

    .tabs {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-right: 20px;

        .type-btn {
            margin-right: 10px;
        }
    }

    .btns {
        display: flex;
        align-items: center;

        .ant-btn {
            margin-left: 10px;
        }

        .downloadBtn {
            background-color: #7101ad;
            border-color: #7101ad;
        }
    }
}

.record-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.record-icon {
    margin-right: 10px;
    width: 6%;
    height: 6%;
}

.record-time {
    margin-left: auto;
}

.list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f2f2f2;
    border-radius: 10px;
    padding: 5px 10px;
    margin-bottom: 10px;
}
</style>